<template>
    <div>
        <el-tabs 
        v-model="activeName"
        class="tab-center"
        >
            <el-tab-pane name="calculter">
                <span slot="label" class="label"
                    v-czc="['交易中心','点击按钮', '收费计算' , 0 ,`tradeCenter-btn-chargeCompute`]"> 
                    收费计算 
                </span>
                <div class="label-form">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="类型">
                            <el-radio-group v-model="form.type" size="mini" @input="radioInput">
                                <el-radio-button  label="0">咨询</el-radio-button>
                                <el-radio-button  label="1">设计</el-radio-button>
                                <el-radio-button  label="2">监理</el-radio-button>
                                <el-radio-button  label="3">招标</el-radio-button>
                                <el-radio-button  label="4">管理</el-radio-button>
                                <el-radio-button  label="5">造价</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>

                    <!-- 咨询组件 -->
                    <consulting v-if="form.type == '0'" @startCompute="startCompute"></consulting>

                    <!-- 设计组件 -->
                    <coefficient v-if="form.type == '1'" @startCompute="startCompute"></coefficient>

                    <!-- 监理组件 -->
                    <supervision v-if="form.type == '2'" @startCompute="startCompute"></supervision>

                    <!-- 招标组件 -->
                    <tender v-if="form.type == '3'" @startCompute="startCompute"></tender>

                    <!-- 管理组件 -->
                    <management v-if="form.type == '4'" @startCompute="startCompute"></management>

                    <!-- 造价组件 -->
                    <cost v-if="form.type == '5'" @startCompute="startCompute"></cost>
                </div>
            </el-tab-pane>

            <el-tab-pane name="cabl">
                <span slot="label" class="label"
                    v-czc="['交易中心','点击按钮', 'CA办理' , 0 ,`tradeCenter-btn-ca`]"> 
                    CA办理 
                </span>

                <ca></ca>
            </el-tab-pane>

            <el-tab-pane name="third">
                <span slot="label" class="label"
                    v-czc="['交易中心','点击按钮', '第三方平台' , 0 ,`tradeCenter-btn-third`]"> 
                    第三方平台 
                </span>

                <third></third>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Coefficient from '../components/coefficient.vue';
import Consulting from '../components/consulting.vue';
import Cost from '../components/cost.vue';
import Management from '../components/management.vue';
import Supervision from '../components/supervision.vue';
import Tender from '../components/tender.vue';
import Third from '../components/third.vue';
import Ca from '../components/ca.vue';

export default {
    components: {
        Consulting,
        Coefficient,
        Supervision,
        Tender,
        Management,
        Cost,
        Third,
        Ca,
    },
    props:{
        activeName:{
            type:String,
            default:'calculter'
        }
    },
    data() {
        return {
            form: {
                type: "0",  //类型
            },
        };
    },
    methods: {
        radioInput(val){
            this.setCzc(['交易中心','筛选', '类型' , val-0+1 ,`tradeCenter-select-type`])
        },
        startCompute(){
            this.setCzc(['交易中心','点击按钮', '开始计算' , 0 ,`tradeCenter-btn-startCompute`])
        },
        /**
         * 设置 form
         * @param {Object} 表单对象
         */
        setForm(obj) {
            this.form = obj
        },
        /**
         * 发送收费计算请求
         */
        calculationCharge(){
            // 下面发请求
        }

    },
};
</script>

<style lang="scss" scoped>
    .label {
        font-size: 17px;
        font-weight: 700;
    }
    .label-form{
        padding-left: 141px;
    }

    .tab-center{
        ::v-deep {
            .el-tabs__nav-wrap::after{
                background: #f0f0f0;
            }
        }
    }
</style>